<template>
  <div>
    <!-- 取消装箱 -->
    <el-dialog :title="$t('message.unpack')" :close-on-click-modal="false" :visible.sync="dialogVisible" width="1708px"
      center>
      <div class="content">
        <!-- 当前箱号 -->
        <div class="boxNum">
          {{ $t("message.presentBoxNum") }}:{{ boxDetail.number }}
        </div>
        <div class="table">
          <ol>
            <!--  番号-->
            <li class="flex05">
              <el-checkbox v-model="checked" @change="allChecked"></el-checkbox>
            </li>
            <!--  番号-->
            <li class="flex05">
              {{ $t("message.mash") }}
            </li>
            <!-- 订单号 -->
            <li class="flex15">{{ $t("message.orderNumber") }}</li>
            <!--照片-->
            <li>
              {{ $t("message.pic") }}
            </li>
            <!-- 商品属性 -->
            <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
            <!-- 数量 -->
            <li>
              {{ $t("message.number") }}
            </li>
            <!-- 商品费用 -->
            <li>{{ $t("message.forGoods") }}</li>
            <!--本箱装货数  -->
            <li class="flex2">{{ $t("message.quantityOfCargoInThisCase") }}</li>
            <!-- 其他箱已装箱数 -->
            <li>{{ $t("message.numberOfOtherBoxesPacked") }}</li>
            <!--取出到具体交易号数量  -->
            <li class="flex2">
              {{ $t("message.takeItOutToASpecificTransactionNumber") }}
            </li>
          </ol>
          <!-- 订单详情 -->
          <div class="proder" v-for="(proder, proderIndex) in boxDetail.list" :key="proderIndex">
            <!-- 配送单号 -->
            <div class="head">{{ proder.porder_sn }}</div>
            <ul v-for="(item, index) in proder.list" :key="index">
              <!--   番号-->
              <li class="flex05">
                <el-checkbox v-model="item.checked"></el-checkbox>
              </li>
              <!--  番号-->
              <li class="flex05">
                {{ item.sorting }}
              </li>
              <!-- 订单号 -->
              <li class="flex15">
                <div>
                  <p>{{ item.order_sn }}</p>
                  <p>{{ item.realname }}</p>
                </div>
              </li>
              <!--照片-->
              <li>
                <div>
                  <div class="img">
                    <el-popover placement="right" width="300" trigger="hover">
                      <img :src="item.pic" alt="" style="width: 300px; height: 300px" />
                      <a :href="`https://detail.1688.com/offer/${item.goods_id}.html`" target="_blank" slot="reference">
                        <img :src="item.pic" alt="" style="width: 60px; height: 60px" />
                      </a>
                    </el-popover>
                  </div>
                </div>
              </li>
              <!-- 商品属性 -->
              <li class="flex15">
                <div class="template">
                  <el-tooltip placement="bottom">
                    <div slot="content">
                      <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex"
                        style="margin-bottom: 5px">
                        {{ itemDetail.key }}：{{ itemDetail.value }}
                      </div>
                    </div>
                    <div>
                      <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex">
                        {{ itemDetail.key }}：{{ itemDetail.value }}
                      </div>
                    </div>
                  </el-tooltip>
                </div>
              </li>
              <!-- 数量 -->
              <li>
                <div>
                  <!-- 提出数 -->
                  <p>{{ $t("message.putForwardNum") }}：{{ item.submitNum }}</p>
                  <!-- 待装箱 -->
                  <p>
                    {{ $t("message.toEncasement") }}：{{ item.wait_freight_num }}
                  </p>
                  <!-- 已装箱 -->
                  <p>{{ $t("message.boxed") }}：{{ item.freight_num }}</p>
                  <!-- 已出货 -->
                  <!-- <p>{{ $t("message.shipped") }}：{{ item.delivery_num }}</p> -->
                </div>
              </li>
              <!-- 价格.元 -->
              <li>
                <div>
                  <p>{{ $t("message.price") }}:{{ item.confirm_price }}</p>
                  <p>{{ $t("message.freight") }}:{{ item.confirm_freight }}</p>
                </div>
              </li>
              <!--本箱装货数  -->
              <li class="flex2">
                <div class="template">
                  <div class="row" v-for="(purchase, purchaseIndex) in item.list" :key="purchaseIndex">
                    <span>
                      JY{{ purchaseIndex + 1 }}:
                      <a href="javascript:;" style="color: #fa5058">
                        {{ purchase.order_purchase.purchase_no }}
                      </a>
                    </span>
                    <!-- 装箱数 -->
                    <span>{{ $t("message.packingNumber") }}:{{ purchase.num }}</span>
                  </div>
                </div>
              </li>
              <!-- 其他箱已装箱数 -->
              <li>
                {{ item.other_freight_num }}
              </li>
              <!--取出到具体交易号数量  -->
              <li class="flex2">
                <div class="template">
                  <div class="row" v-for="(purchase, purchaseIndex) in item.list" :key="purchaseIndex">
                    <span>
                      JY{{ purchaseIndex + 1 }}:
                      <a href="javascript:;" style="color: #fa5058">{{ purchase.order_purchase.purchase_no }}</a>
                    </span>
                    <!-- 取消装箱数 -->
                    <span>
                      <el-input v-model="purchase.cancelEncasementNum" onfocus="this.select()"
                        @input="maxNum(proderIndex, index, purchaseIndex)"
                        onkeyup.native="value=value.replace(/^(0+)|[^\d]+/g,'')" size="small"></el-input>
                    </span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 取消装箱 -->
        <el-button type="primary" @click="unpack">
          {{ $t("message.unpack") }}
        </el-button>
      </span>
    </el-dialog>
    <!-- 仓库 -->
    <warehouse v-if="warehouseDialogVisible" :type="4" :shelf_type_set="[1, 2, 3, 4]"
      :cancelEncasementData="cancelEncasementData" />
  </div>
</template>
<script>
import { mapState } from "vuex";
import warehouse from "@/components/common/warehouse";
export default {
  data() {
    return {
      dialogVisible: false,
      porder_sn: this.$route.query.porder_sn,
      warehouseDialogVisible: false, //仓库
      cancelEncasementData: {}, //取消装箱数据
      checked: false,
    };
  },
  computed: {
    ...mapState({
      boxDetail: (state) => state.porderDetail.boxDetail,
    }),
  },
  components: {
    warehouse,
  },
  methods: {
    //取出装箱数最大数
    maxNum(proderIndex, index, purchaseIndex) {
      let item =
        this.boxDetail.list[proderIndex].list[index].list[purchaseIndex];
      if (item.cancelEncasementNum > item.num) {
        item.cancelEncasementNum = item.num;
        this.$message.error("取出数量不能大于本箱装货数");
        this.$forceUpdate();
      }
    },
    // 取消装箱
    unpack() {
      this.cancelEncasementData = {
        freight_id: this.boxDetail.freight_id,
        grid_number: "",
        list: [],
      };
      //   取出数据
      this.boxDetail.list.forEach((porder) => {
        porder.list.forEach((item) => {
          if (item.checked) {
            item.list.forEach((items) => {
              this.cancelEncasementData.list.push({
                porder_sn: porder.porder_sn,
                order_purchase_id: items.order_purchase_id,
                num_out: items.cancelEncasementNum,
              });
            });
          }
        });
      });
      if (this.cancelEncasementData.list == false) return this.$message.error('未选择要取消装箱的商品')
      this.warehouseDialogVisible = true;
    },
    // 全选
    allChecked() {
      this.boxDetail.list.forEach(item => {
        item.list.forEach(items => {
          items.checked = this.checked
        })
      })
    },
    // 取出箱子成功
    takeOutSucess() {
      this.dialogVisible = false;
      this.warehouseDialogVisible = false;
      this.$store.dispatch("porderDetail", { porder_sn: this.porder_sn });
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0 15px;

  .boxNum {
    font-size: 18px;
    margin-bottom: 10px;
  }

  .table {
    .head {
      line-height: 40px;
      font-size: 18px;
      border-bottom: 1px solid #dedede;
    }

    .template {
      width: 100%;
      text-align: left;
    }

    .flex05 {
      flex: 0.5;
    }

    .flex15 {
      flex: 1.5;
    }

    .flex2 {
      flex: 2;
    }

    .row {
      display: flex;
      margin-bottom: 5px;
      line-height: 32px;

      &:nth-last-child(1) {
        margin: 0;
      }

      span {
        flex: 3;

        &:nth-child(2) {
          flex: 1;
        }
      }
    }
  }
}
</style>
